import React, { useState } from 'react';
import { toast } from 'react-toastify';
import BlogService from '../../services/BlogServices';

const UpdateSchemaModal = ({ blog, selectedWebsite, onClose }) => {
  const [formData, setFormData] = useState({
    webId: selectedWebsite,
    blogId: blog?.id,
    schema: blog?.schema || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData?.blogId || !formData?.webId) {
      toast.error('BlogId and WebId are required.');
      return;
    }
    
    try {
        await BlogService.setSchema(formData); // API call to update
        toast.success('schema updated successfully.');
        onClose();
    } catch (error) {
      toast.error(error.message || 'Failed to update schema.');
    }
  };

  return (
    <div className="modal show d-block">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update Schema - {blog.title}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-group mb-3">
                <label htmlFor="schema" className="form-label">
                    Blog Schema
                </label>
                <textarea
                    id="schema"
                    name="schema"
                    className="form-control"
                    rows="10"
                    placeholder="Enter blog schema"
                    value={formData.schema}
                    onChange={handleInputChange}
                    required
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateSchemaModal;
